// #region  main
export const SET_MAP = "SET_MAP";
export const LOG_HISTORY = "LOG_HISTORY";
export const ADD_PLAN_ID = "ADD_PLAN_ID";
export const CLEAR_STATE = "CLEAR_STATE";
export const MAP_DRAWER_TAB = "MAP_DRAWER_TAB";
export const TOGGLE_MENU_ITEM = "TOGGLE_MENU_ITEM";
export const FIND_MISSION_CARD = "FIND_MISSION_CARD";
export const SCREEN_MUST_FREEZE = "SCREEN_MUST_FREEZE";
export const CHANGE_CONTEXT_MENU = "CHANGE_CONTEXT_MENU";
export const STOP_WORKING_BUTTONS = "STOP_WORKING_BUTTONS";
export const SET_CANT_DO_EDIT_AFTER_GET_EXTERNAL =
  "SET_CANT_DO_EDIT_AFTER_GET_EXTERNAL";
export const CHANGE_MAP_VIEW_STATE = "CHANGE_MAP_VIEW_STATE";
export const TOGGLE_SOCKET_LISTENING = "TOGGLE_SOCKET_LISTENING";
export const CHANGE_LIVETRACK_MAP_TAB = "CHANGE_LIVETRACK_MAP_TAB";
export const CHANGE_DATA_FOR_PLAN_RESET = "CHANGE_DATA_FOR_PLAN_RESET";
export const TOGGLE_SOCKET_LIVETACK_LISTENING =
  "TOGGLE_SOCKET_LIVETACK_LISTENING";
// #endregion main

// #region polygons
export const SELECT_POLYGON = "SELECT_POLYGON";
export const CHANGE_POLYGONS = "CHANGE_POLYGONS";
export const UPDATE_POLYGONS_LIST = "UPDATE_POLYGONS_LIST";
export const UPDATE_POLYGON_SETTING = "UPDATE_POLYGON_SETTING";
export const SET_SHOW_ONLY_NO_DRIVER_POLYGONS = "SET_SHOW_ONLY_NO_DRIVER_POLYGONS";
// #endregion polygons

// #region pins
export const SELECT_PIN = "SELECT_PIN";
export const UPDATE_PIN_SETTING = "UPDATE_PIN_SETTING";
// #endregion pins

// #region liveTrack
export const NEXT_PREV_MISSION = "NEXT_PREV_MISSION";
export const CHANGE_DRIVER_VEHICLE = "CHANGE_DRIVER_VEHICLE";
export const UPDATE_LIVETRACK_ITEMS = "UPDATE_LIVETRACK_ITEMS";
export const UPDATE_LIVETRACK_DRIVERS = "UPDATE_LIVETRACK_DRIVERS";
export const UPDATE_SINGLE_DRIVER_INFO = "UPDATE_SINGLE_DRIVER_INFO";
export const GO_TO_DRIVER_MISSION_INFO = "GO_TO_DRIVER_MISSION_INFO";

export const GET_ACTUAL_ROUTE = "GET_ACTUAL_ROUTE";
export const GET_ACTUAL_ROUTE_FAIL = "GET_ACTUAL_ROUTE_FAIL";
export const GET_ACTUAL_ROUTE_SUCCESS = "GET_ACTUAL_ROUTE_SUCCESS";
// #endregion liveTrack

//#region data fetching
export const PLAN_RESET = "PLAN_RESET";
export const PLAN_RESET_FAIL = "PLAN_RESET_FAIL";
export const PLAN_RESET_SUCCESS = "PLAN_RESET_SUCCESS";

export const DRIVER_ACTIVATION = "DRIVER_ACTIVATION";
export const DRIVER_ACTIVATION_FAIL = "DRIVER_ACTIVATION_FAIL";
export const DRIVER_ACTIVATION_SUCCESS = "DRIVER_ACTIVATION_SUCCESS";

export const GET_MISSION_INFO = "GET_MISSION_INFO";
export const GET_MISSION_INFO_FAIL = "GET_MISSION_INFO_FAIL";
export const GET_MISSION_INFO_SUCCESS = "GET_MISSION_INFO_SUCCESS";

export const DISPATCH_TO_DRIVER = "DISPATCH_TO_DRIVER";
export const DISPATCH_TO_DRIVER_FAIL = "DISPATCH_TO_DRIVER_FAIL";
export const DISPATCH_TO_DRIVER_SUCCESS = "DISPATCH_TO_DRIVER_SUCCESS";

export const GET_PLAN_INFO = "GET_PLAN_INFO";
export const GET_PLAN_INFO_FAIL = "GET_PLAN_INFO_FAIL";
export const GET_PLAN_INFO_SUCCESS = "GET_PLAN_INFO_SUCCESS";

export const GET_PLAN_PREVIEW_INFO = "GET_PLAN_PREVIEW_INFO";
export const GET_PLAN_PREVIEW_INFO_FAIL = "GET_PLAN_PREVIEW_INFO_FAIL";
export const GET_PLAN_PREVIEW_INFO_SUCCESS = "GET_PLAN_PREVIEW_INFO_SUCCESS";

export const SAVE_PLAN_PREVIEW_INFO = "SAVE_PLAN_PREVIEW_INFO";
export const SAVE_PLAN_PREVIEW_INFO_FAIL = "SAVE_PLAN_PREVIEW_INFO_FAIL";
export const SAVE_PLAN_PREVIEW_INFO_SUCCESS = "SAVE_PLAN_PREVIEW_INFO_SUCCESS";

export const GET_PLAN_LIGHT_INFO = "GET_PLAN_LIGHT_INFO";
export const GET_PLAN_LIGHT_INFO_FAIL = "GET_PLAN_LIGHT_INFO_FAIL";
export const GET_PLAN_LIGHT_INFO_SUCCESS = "GET_PLAN_LIGHT_INFO_SUCCESS";

export const AUTO_DRIVER_ASSIGN = "AUTO_DRIVER_ASSIGN";
export const AUTO_DRIVER_ASSIGN_FAIL = "AUTO_DRIVER_ASSIGN_FAIL";
export const AUTO_DRIVER_ASSIGN_SUCCESS = "AUTO_DRIVER_ASSIGN_SUCCESS";

export const GET_NEXT_PREV_PLAN = "GET_NEXT_PREV_PLAN";
export const GET_NEXT_PREV_PLAN_FAIL = "GET_NEXT_PREV_PLAN_FAIL";
export const GET_NEXT_PREV_PLAN_SUCCESS = "GET_NEXT_PREV_PLAN_SUCCESS";

export const UPLOAD_LAST_PIN = "UPLOAD_LAST_PIN";
export const UPLOAD_LAST_PIN_FAIL = "UPLOAD_LAST_PIN_FAIL";
export const UPLOAD_LAST_PIN_SUCCESS = "UPLOAD_LAST_PIN_SUCCESS";

export const CONFIRM_LAST_PIN = "CONFIRM_LAST_PIN";
export const CONFIRM_LAST_PIN_FAIL = "CONFIRM_LAST_PIN_FAIL";
export const CONFIRM_LAST_PIN_SUCCESS = "CONFIRM_LAST_PIN_SUCCESS";

export const GET_PLAN_STATUS = "GET_PLAN_STATUS";
export const GET_PLAN_STATUS_FAIL = "GET_PLAN_STATUS_FAIL";
export const GET_PLAN_STATUS_SUCCESS = "GET_PLAN_STATUS_SUCCESS";

export const GET_REMAIN_PIN_COORDS = "GET_REMAIN_PIN_COORDS";
export const GET_REMAIN_PIN_COORDS_FAIL = "GET_REMAIN_PIN_COORDS_FAIL";
export const GET_REMAIN_PIN_COORDS_SUCCESS = "GET_REMAIN_PIN_COORDS_SUCCESS";

export const REMOVE_DRIVER_FROM_POLYGON = "REMOVE_DRIVER_FROM_POLYGON";
export const REMOVE_DRIVER_FROM_POLYGON_FAIL =
  "REMOVE_DRIVER_FROM_POLYGON_FAIL";
export const REMOVE_DRIVER_FROM_POLYGON_SUCCESS =
  "REMOVE_DRIVER_FROM_POLYGON_SUCCESS";

export const REMOVE_DISTRIBUTOR_FROM_POLYGON =
  "REMOVE_DISTRIBUTOR_FROM_POLYGON";
export const REMOVE_DISTRIBUTOR_FROM_POLYGON_FAIL =
  "REMOVE_DISTRIBUTOR_FROM_POLYGON_FAIL";
export const REMOVE_DISTRIBUTOR_FROM_POLYGON_SUCCESS =
  "REMOVE_DISTRIBUTOR_FROM_POLYGON_SUCCESS";

export const GET_LIVETRACK_DRIVERS = "GET_LIVETRACK_DRIVERS";
export const GET_LIVETRACK_DRIVERS_FAIL = "GET_LIVETRACK_DRIVERS_FAIL";
export const GET_LIVETRACK_DRIVERS_SUCCESS = "GET_LIVETRACK_DRIVERS_SUCCESS";

export const GET_DRIVER_MISSION_INFO = "GET_DRIVER_MISSION_INFO";
export const GET_DRIVER_MISSION_INFO_FAIL = "GET_DRIVER_MISSION_INFO_FAIL";
export const GET_DRIVER_MISSION_INFO_SUCCESS =
  "GET_DRIVER_MISSION_INFO_SUCCESS";

export const GET_DRIVER_MISSION_INFO_COUNT = "GET_DRIVER_MISSION_INFO_COUNT";
export const GET_DRIVER_MISSION_INFO_COUNT_FAIL =
  "GET_DRIVER_MISSION_INFO_COUNT_FAIL";
export const GET_DRIVER_MISSION_INFO_COUNT_SUCCESS =
  "GET_DRIVER_MISSION_INFO_COUNT_SUCCESS";

export const CHANGE_MISSION_STATUS = "CHANGE_MISSION_STATUS";
export const CHANGE_MISSION_STATUS_FAIL = "CHANGE_MISSION_STATUS_FAIL";
export const CHANGE_MISSION_STATUS_SUCCESS = "CHANGE_MISSION_STATUS_SUCCESS";

export const GET_MISSION_STATUS_EXCEL = "GET_MISSION_STATUS_EXCEL";
export const GET_MISSION_STATUS_EXCEL_FAIL = "GET_MISSION_STATUS_EXCEL_FAIL";
export const GET_MISSION_STATUS_EXCEL_SUCCESS =
  "GET_MISSION_STATUS_EXCEL_SUCCESS";

export const SEARCH_IN_LIVETRACK = "SEARCH_IN_LIVETRACK";
export const SEARCH_IN_LIVETRACK_FAIL = "SEARCH_IN_LIVETRACK_FAIL";
export const SEARCH_IN_LIVETRACK_SUCCESS = "SEARCH_IN_LIVETRACK_SUCCESS";

export const GET_ALL_MISSION_POD = "GET_ALL_MISSION_POD";
export const GET_ALL_MISSION_POD_FAIL = "GET_ALL_MISSION_POD_FAIL";
export const GET_ALL_MISSION_POD_SUCCESS = "GET_ALL_MISSION_POD_SUCCESS";

export const GET_CITY_LAYERS = "GET_CITY_LAYERS";
export const GET_CITY_LAYERS_FAIL = "GET_CITY_LAYERS_FAIL";
export const GET_CITY_LAYERS_SUCCESS = "GET_CITY_LAYERS_SUCCESS";

export const GET_ACTUAL_DELIVERY_MISSION = "GET_ACTUAL_DELIVERY_MISSION";
export const GET_ACTUAL_DELIVERY_MISSION_FAIL =
  "GET_ACTUAL_DELIVERY_MISSION_FAIL";
export const GET_ACTUAL_DELIVERY_MISSION_SUCCESS =
  "GET_ACTUAL_DELIVERY_MISSION_SUCCESS";

export const AUTO_ASSIGN_MICROHUBS = "AUTO_ASSIGN_MICROHUBS";
export const AUTO_ASSIGN_MICROHUBS_FAIL = "AUTO_ASSIGN_MICROHUBS_FAIL";
export const AUTO_ASSIGN_MICROHUBS_SUCCESS = "AUTO_ASSIGN_MICROHUBS_SUCCESS";

export const ADD_NEW_PIN_TO_PLAN = "ADD_NEW_PIN_TO_PLAN";
export const ADD_NEW_PIN_TO_PLAN_SUCCESS = "ADD_NEW_PIN_TO_PLAN_SUCCESS";
export const ADD_NEW_PIN_TO_PLAN_FAIL = "ADD_NEW_PIN_TO_PLAN_FAIL";

export const EDIT_VEHICLE_NAME = "EDIT_VEHICLE_NAME";
export const EDIT_VEHICLE_NAME_SUCCESS = "EDIT_VEHICLE_NAME_SUCCESS";
export const EDIT_VEHICLE_NAME_FAIL = "EDIT_VEHICLE_NAME_FAIL";

export const GET_LIVETRACK_INFO = "GET_LIVETRACK_INFO";
export const GET_LIVETRACK_INFO_SUCCESS = "GET_LIVETRACK_INFO_SUCCESS";
export const GET_LIVETRACK_INFO_FAIL = "GET_LIVETRACK_INFO_FAIL";

export const GET_MISSION_CONFIRMATION = "GET_MISSION_CONFIRMATION";
export const GET_MISSION_CONFIRMATION_SUCCESS =
  "GET_MISSION_CONFIRMATION_SUCCESS";
export const GET_MISSION_CONFIRMATION_FAIL = "GET_MISSION_CONFIRMATION_FAIL";

export const SET_MISSION_CONFIRMATION = "SET_MISSION_CONFIRMATION";
export const SET_MISSION_CONFIRMATION_SUCCESS =
  "SET_MISSION_CONFIRMATION_SUCCESS";
export const SET_MISSION_CONFIRMATION_FAIL = "SET_MISSION_CONFIRMATION_FAIL";

export const CHANGE_MISSIONS_ORDER = "CHANGE_MISSIONS_ORDER";
export const CHANGE_MISSIONS_ORDER_SUCCESS = "CHANGE_MISSIONS_ORDER_SUCCESS";
export const CHANGE_MISSIONS_ORDER_FAIL = " CHANGE_MISSIONS_ORDER_FAIL";

export const REQUEST_VEHICLE = "REQUEST_VEHICLE";
export const REQUEST_VEHICLE_SUCCESS = "REQUEST_VEHICLE_SUCCESS";
export const REQUEST_VEHICLE_FAIL = " REQUEST_VEHICLE_FAIL";

export const GET_CHAT_MESSAGES = "GET_CHAT_MESSAGES";
export const GET_CHAT_MESSAGES_SUCCESS = "GET_CHAT_MESSAGES_SUCCESS";
export const GET_CHAT_MESSAGES_FAIL = " GET_CHAT_MESSAGES_FAIL";

export const DEACTIVE_DRIVERS = "DEACTIVE_DRIVERS";
export const DEACTIVE_DRIVERS_SUCCESS = "DEACTIVE_DRIVERS_SUCCESS";
export const DEACTIVE_DRIVERS_FAIL = " DEACTIVE_DRIVERS_FAIL";

// #endregion data fetching
